import Tailer_One from "../../../assets/images/Tailer_One.jpg";
import Tailer_three from "../../../assets/images/IMG_8351.jpg";
import Tailer_Two from "../../../assets/images/Tailer_Two.jpg";
import Accessory_Two from "../../../assets/images/Accessory_Two.png";
import Accessory_Bench_Seat from "../../../assets/images/Accessory_Bench_Seat.jpg";
import Accessory_Three from "../../../assets/images/Accessory_Three.png";
import Center_Console_Two from "../../../assets/images/Center_Console_Two.jpg";
import Center_Console_One from "../../../assets/images/Center_Console_One.jpg";
import eTuatarastainlesscage from "../../../assets/images/eTuatarastainlesscage.jpg";
import eTuatarastainlesscage1 from "../../../assets/images/eTuatarastainlesscage1.jpg";
import Accessory_Trailer from "../../../assets/images/Tuatara1000Trailer(5).jpg";
import Center_Console_Three from "../../../assets/images/AccessoryCentralConsole.jpg";
import Center_Console_four from "../../../assets/images/AccessoryCentralConsole1.jpg";
import Center_Console_five from "../../../assets/images/AccessoryCentralConsole2.jpg";
import Center_Console_six from "../../../assets/images/ConsoleDesign.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRef, useState } from "react";
const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-prev`}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        left: "10px", // Adjust left position
        zIndex: 1, // Ensure it appears above everything
        backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent background
        width: "40px",
        height: "40px",
        borderRadius: "50%", // Circular button
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {/* <span style={{ color: "#fff", fontSize: "24px" }}>◀</span> */}
    </div>
  );
};

// Custom Right Arrow
const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-next`}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "20px", // Adjust right position
        zIndex: 1, // Ensure it appears above everything
        backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent background
        width: "40px",
        height: "40px",
        borderRadius: "50%", // Circular button
        cursor: "pointer",
        opacity: 1,
      }}
      onClick={onClick}
    >
      {/* <span style={{ color: "#fff", fontSize: "24px" }}>▶</span> */}
    </div>
  );
};
const NZOtherAccessories = () => {
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const [openImage, setOpenImage] = useState(null);

  const accessories = [
    {
      id: 1,
      image: [Tailer_One, Accessory_Trailer],
      name: "Trailer",
      containIndexes: [0],
      details: [
        "Trailer cargo tray hoist can be operated from Tuatara  passenger cabin.",
        "Fitted with tail, braking, reversing, number plate and turn signal lights.",
        "Dual coil springs on both wheels.",
        "Can be road registered.",
        "Can be fitted with a deck cage.",
        "Can be attached to other vehicles.",
        "Dimensions: (L x W) 2760 x 1480mm.",
        "Deck dimensions: (L x W x H) 1600 x 1400 x 300mm.",
        "Carrying capacity: 800kg.",
      ],
    },
    {
      id: 2,
      image: [eTuatarastainlesscage, eTuatarastainlesscage1],
      name: "Cage",
      containIndexes: [0],
      details: [
        "Stainless steel construction.",
        "Installable on vehicle or trailer.",
        "Sliding rear gates (2) with latch.",
        "Available for petrol & electric models.",
      ],
    },
    {
      id: 3,
      image: [Accessory_Bench_Seat],
      name: "Accessory Bench Seat",
      objectFit: "contain",
      details: [
        "Head protection in the event of roll-over",
        "4-point seat belts",
        "Solidly bolted to cargo bed",
      ],
    },
    {
      id: 4,
      image: [
        Center_Console_Three,
        Center_Console_four,
        Center_Console_five,
        Center_Console_six,
      ],
      containIndexes: [3],
      name: "Centre Console",
      details: ["Seat covers", "Heavy duty rubber mat rear cargo deck"],
    },
    {
      id: 4,
      image: [],
      name: "Extras",
      details: ["Seat covers", "Heavy duty rubber mat rear cargo deck"],
    },
  ];
  return (
    <div className="mt-[30px] mb-[30px]">
      <div className="custom-container px-[30px] text-start mx-auto">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="text-[48px] md:text-[36px] text-gray-800 kuunari-bold text-center mb-10">
            Other Accessories:
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-x-8 gap-4">
            {accessories.map((accessory) => (
              <AccessoryItem
                key={accessory.id}
                {...accessory}
                tooltipPos={tooltipPos}
                setTooltipPos={setTooltipPos}
                showTooltip={showTooltip}
                setShowTooltip={setShowTooltip}
                setOpenImage={setOpenImage}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div
          className="fixed z-[9999] bg-black text-white text-[13px] px-3 py-1 rounded-md shadow-lg pointer-events-none"
          style={{
            top: tooltipPos.y + 15,
            left: tooltipPos.x + 15,
          }}
        >
          Click here to expand
        </div>
      )}

      {/* Fullscreen Image Modal */}
      {openImage && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
          onClick={() => setOpenImage(null)}
        >
          {/* CLOSE BUTTON outside image, fixed at top-right */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpenImage(null);
            }}
            className="
        fixed top-4 right-4
        text-white text-4xl font-bold
        bg-black/70 hover:bg-black
        p-2 rounded-full
        z-[10000]
      "
          >
            ✕
          </button>

          {/* IMAGE */}
          <img
            src={openImage}
            alt="Expanded View"
            className="max-w-[95%] max-h-[95%] rounded-lg object-contain shadow-xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

function AccessoryItem({
  image,
  name,
  details,
  tooltipPos,
  setTooltipPos,
  showTooltip,
  setShowTooltip,
  setOpenImage,
  objectFit,
  containIndexes,
}) {
  const sliderRef = useRef(null);
  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000, // Slower slide change (was 6000)
    // prevArrow: <CustomPrevArrow />, // Custom arrow components
    // nextArrow: <CustomNextArrow />,
  };
  return (
    <article className="text-center ">
      {image && image.length > 1 && (
        // <Slider {...settings} className="w-full h-[400px] rounded-lg">
        //   {image.map((img, index) => (
        //     <div key={index} className="w-full h-[400px]">
        //       <img
        //         src={img}
        //         alt={`${name} ${index + 1}`}
        //         className="w-full h-[400px]  rounded-lg object-cover"
        //         loading="lazy"
        //       />
        //     </div>
        //   ))}
        // </Slider>
        <div className="relative w-full aspect-[4/3]">
          {/* Custom Previous Arrow */}
          {image.length > 1 && (
            <div
              className="absolute left-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              <FaChevronLeft className="text-white text-sm" />
            </div>
          )}

          {/* Image Slider */}
          <Slider
            ref={sliderRef}
            {...settings}
            className="w-full h-full rounded-lg"
          >
            {image.map((img, index) => (
              <div key={index} className="w-full aspect-[4/3]">
                <img
                  src={img}
                  alt={`Accessory ${index + 1}`}
                  loading="lazy"
                  className={`w-full h-[98%] rounded-lg cursor-pointer ${
                    containIndexes && containIndexes.includes(index)
                      ? "object-contain border border-black"
                      : "object-cover"
                  }`}
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => setOpenImage(img)}
                />
              </div>
            ))}
          </Slider>

          {/* Custom Next Arrow */}
          {image.length > 1 && (
            <div
              className="absolute right-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
              onClick={() => sliderRef.current?.slickNext()}
            >
              <FaChevronRight className="text-white text-sm" />
            </div>
          )}
        </div>
      )}
      {image && image.length === 1 && (
        <div className="w-full aspect-[4/3]">
          <img
            src={image[0]}
            alt={name}
            className={`w-full h-full border border-black rounded-lg cursor-pointer ${
              objectFit === "contain" ? "object-contain" : "object-cover"
            }`}
            loading="lazy"
            onMouseMove={(e) => {
              setTooltipPos({ x: e.clientX, y: e.clientY });
              setShowTooltip(true);
            }}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={() => setOpenImage(image[0])}
          />
        </div>
      )}

      <h3 className="text-[22px] kuunari-bold text-gray-800 mb-2 text-center">
        {name}
      </h3>
      <AccessoryDetails details={details} />
    </article>
  );
}

function AccessoryDetails({ details }) {
  return (
    <ul className="text-left text-gray-600 text-[16px] space-y-1">
      {details.map((detail, index) => (
        <li key={index} className="flex items-start gap-2">
          <span>➢</span> {detail}
        </li>
      ))}
    </ul>
  );
}

export default NZOtherAccessories;
